import React from 'react';
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    TextField,
    IconButton,
    Typography,
    Autocomplete,
    Chip
} from '@mui/material';
import { Clear as ClearIcon, Delete as DeleteIcon } from '@mui/icons-material';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ru from 'date-fns/locale/ru';
import '../../../styles/DatePicker.css';

// Регистрируем русскую локаль
registerLocale('ru', ru);


// Компонент для продвинутой фильтрации
export const AdvancedFiltersComponent = ({
    darkMode,
    advancedFilters,
    onClearFilters,
    addFilter,
    removeFilter,
    updateFilter,
    getAvailableFiltersForSelect,
    filterMode,
    handleFilterModeChange
}) => {
    const dateOperators = [
        { value: 'equals', label: 'Равно' },
        { value: 'greater', label: 'Больше' },
        { value: 'less', label: 'Меньше' },
        { value: 'between', label: 'Между' }
    ];

    const numberOperators = [
        { value: 'equals', label: 'Равно' },
        { value: 'greater', label: 'Больше' },
        { value: 'less', label: 'Меньше' }
    ];

    const booleanOperators = [
        { value: 'true', label: 'Да' },
        { value: 'false', label: 'Нет' }
    ];

    const andOrOperators = [
        { value: 'and', label: 'И (все значения)' },
        { value: 'or', label: 'ИЛИ (любое из значений)' }
    ]

    const equalsOperators = [
        { value: 'equals', label: 'Равно' },
        { value: 'not_equals', label: 'Не равно' }
    ]

    const handleFilterChange = (filterId, key, value) => {
        updateFilter(filterId, { [key]: value });
    };

    const handleDateFilterChange = (filterId, value) => {
        updateFilter(filterId, { value });
    };

    const handleMultiSelectChange = (filterId, values) => {
        updateFilter(filterId, { value: values });
    };



    const getActiveFiltersCount = () => {
        return advancedFilters.length;
    };

    const renderFilterControl = (filter) => {
        console.log(filter)
        switch (filter.type) {
            case 'date':
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <FormControl size="small" fullWidth>
                            <Select
                                value={filter.operator}
                                onChange={(e) => handleFilterChange(filter.id, 'operator', e.target.value)}
                                sx={{
                                    bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontSize: '0.7rem',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            '& .MuiMenuItem-root': {
                                                color: darkMode ? '#f5f7fa' : '#333',
                                                fontSize: '0.7rem',
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                                },
                                                '&.Mui-selected': {
                                                    bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)',
                                                    color: darkMode ? '#64b5f6' : '#1976d2'
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                {dateOperators.map(op => (
                                    <MenuItem key={op.value} value={op.value} sx={{ fontSize: '0.7rem' }}>
                                        {op.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {filter.operator === 'between' ? (
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                <DatePicker
                                    selected={filter.value}
                                    onChange={(date) => handleDateFilterChange(filter.id, date)}
                                    dateFormat="dd.MM.yyyy"
                                    locale="ru"
                                    placeholderText="От"
                                    showYearDropdown
                                    showMonthDropdown
                                    dropdownMode="select"
                                    yearDropdownItemNumber={10}
                                    scrollableYearDropdown
                                    autoComplete="off"
                                    customInput={
                                        <TextField
                                            size="small"
                                            sx={{
                                                flex: 1,
                                                '& .MuiOutlinedInput-input': {
                                                    p: '5px',
                                                    cursor: 'pointer',
                                                    color: darkMode ? '#ffffff' : '#333',
                                                    fontSize: '0.7rem',
                                                },
                                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                                    borderWidth: '2px',
                                                },
                                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                                                    borderRadius: '4px',
                                                },
                                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                                '& .MuiInputBase-root': {
                                                    fontWeight: 500,
                                                    fontSize: '0.7rem',
                                                    borderRadius: '4px',
                                                },
                                                '& .MuiInputBase-input': {
                                                    borderRadius: '4px',
                                                },
                                            }}
                                        />
                                    }
                                    calendarClassName={darkMode ? 'dark-datepicker' : 'light-datepicker'}
                                />
                                <DatePicker
                                    selected={filter.value2}
                                    onChange={(date) => handleFilterChange(filter.id, 'value2', date)}
                                    dateFormat="dd.MM.yyyy"
                                    locale="ru"
                                    placeholderText="До"
                                    showYearDropdown
                                    showMonthDropdown
                                    dropdownMode="select"
                                    yearDropdownItemNumber={10}
                                    scrollableYearDropdown
                                    autoComplete="off"
                                    customInput={
                                        <TextField
                                            size="small"
                                            sx={{
                                                flex: 1,
                                                '& .MuiOutlinedInput-input': {
                                                    p: '5px',
                                                    cursor: 'pointer',
                                                    color: darkMode ? '#ffffff' : '#333',
                                                    fontSize: '0.7rem',
                                                },
                                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                                    borderWidth: '2px',
                                                },
                                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                                                    borderRadius: '4px',
                                                },
                                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                                '& .MuiInputBase-root': {
                                                    fontWeight: 500,
                                                    fontSize: '0.7rem',
                                                    borderRadius: '4px',
                                                },
                                                '& .MuiInputBase-input': {
                                                    borderRadius: '4px',
                                                },
                                            }}
                                        />
                                    }
                                    calendarClassName={darkMode ? 'dark-datepicker' : 'light-datepicker'}
                                />
                            </Box>
                        ) : (
                            <DatePicker
                                selected={filter.value}
                                onChange={(date) => handleDateFilterChange(filter.id, date)}
                                dateFormat="dd.MM.yyyy"
                                locale="ru"
                                placeholderText="Дата"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                yearDropdownItemNumber={10}
                                scrollableYearDropdown
                                autoComplete="off"
                                customInput={
                                    <TextField
                                        size="small"
                                        fullWidth
                                        sx={{
                                            '& .MuiOutlinedInput-input': {
                                                p: '5px',
                                                cursor: 'pointer',
                                                color: darkMode ? '#ffffff' : '#333',
                                                fontSize: '0.7rem',
                                            },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                                borderWidth: '2px',
                                            },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                                                borderRadius: '4px',
                                            },
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            '& .MuiInputBase-root': {
                                                fontWeight: 500,
                                                fontSize: '0.7rem',
                                                borderRadius: '4px',
                                            },
                                            '& .MuiInputBase-input': {
                                                borderRadius: '4px',
                                            },
                                        }}
                                    />
                                }
                                calendarClassName={darkMode ? 'dark-datepicker' : 'light-datepicker'}
                            />
                        )}
                    </Box>
                );

            case 'number':
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <FormControl size="small" fullWidth>
                            <Select
                                value={filter.operator}
                                onChange={(e) => handleFilterChange(filter.id, 'operator', e.target.value)}
                                sx={{
                                    bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontSize: '0.7rem',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            '& .MuiMenuItem-root': {
                                                color: darkMode ? '#f5f7fa' : '#333',
                                                fontSize: '0.7rem',
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                                },
                                                '&.Mui-selected': {
                                                    bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)',
                                                    color: darkMode ? '#64b5f6' : '#1976d2'
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                {numberOperators.map(op => (
                                    <MenuItem key={op.value} value={op.value} sx={{ fontSize: '0.7rem' }}>
                                        {op.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            size="small"
                            fullWidth
                            type="number"
                            value={filter.value || ''}
                            onChange={(e) => handleFilterChange(filter.id, 'value', e.target.value)}
                            // placeholder="Введите номер этапа..."
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontSize: '0.7rem',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                    }
                                },
                                '& .MuiInputBase-input': {
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    '&::placeholder': {
                                        color: darkMode ? '#bbb' : '#666',
                                        opacity: 1
                                    }
                                }
                            }}
                        />
                    </Box>
                );

            case 'multi-select':
                let options = filter.options;
                console.log(options)

                // if (filter.id === 'checklist') {
                //     // Для чек-листа используем rulesMap
                //     options = Object.keys(rulesMap).map(code => ({ id: code, name: `${code} - ${rulesMap[code]?.name || 'Неизвестно'}`, label: code }));
                // } else if (filter.id === 'status') {
                //     // Для статусов используем доступные статусы
                //     options = Object.entries(statuses).filter(([key, value]) => value.filter.length === 1).map(([key, value]) => ({ id: key, name: key, label: key }));
                // } else if (filter.id === 'complexity') {
                //     // Для сложности используем предопределенные значения
                //     options = [
                //         { id: 'low', name: 'Низкая', label: 'Низкая' },
                //         { id: 'medium', name: 'Средняя', label: 'Средняя' },
                //         { id: 'high', name: 'Высокая', label: 'Высокая' }
                //     ];
                // } else if (filter.id.includes('user')) {
                //     options = users.map(user => ({ id: user.id, name: user.name, label: user.name }));
                // }
                // console.log(options)
                const getChipColor = (filterId) => {
                    // Используем originalId для определения цвета, если он есть
                    const originalId = filter.originalId || filterId;
                    switch (originalId) {
                        case 'responsible': return darkMode ? '#64b5f6' : '#1976d2';
                        case 'coexecutors': return darkMode ? '#ff9800' : '#f57c00';
                        case 'equipment': return darkMode ? '#5c6bc0' : '#3949ab';
                        case 'creator': return darkMode ? '#4caf50' : '#388e3c';
                        case 'modifier': return darkMode ? '#9c27b0' : '#7b1fa2';
                        default: return darkMode ? '#64b5f6' : '#1976d2';
                    }
                };

                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        {/* Переключатель логики И/ИЛИ */}
                        <FormControl size="small" fullWidth>
                            <Select
                                value={filter.logic || 'or'}
                                onChange={(e) => handleFilterChange(filter.id, 'logic', e.target.value)}
                                sx={{
                                    bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontSize: '0.7rem',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            '& .MuiMenuItem-root': {
                                                color: darkMode ? '#f5f7fa' : '#333',
                                                fontSize: '0.7rem',
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                                },
                                                '&.Mui-selected': {
                                                    bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)',
                                                    color: darkMode ? '#64b5f6' : '#1976d2'
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                {filter.operator === 'equals' ?

                                    equalsOperators.map(eq => (
                                        <MenuItem value={eq.value} sx={{ fontSize: '0.7rem' }}>
                                            {eq.label}
                                        </MenuItem>
                                    ))
                                    :

                                    andOrOperators.map(eq => (
                                        <MenuItem value={eq.value} sx={{ fontSize: '0.7rem' }}>
                                            {eq.label}
                                        </MenuItem>
                                    ))
                                }
                                {/* <MenuItem value="or" sx={{ fontSize: '0.7rem' }}>
                                    ИЛИ (любое из значений)
                                </MenuItem>
                                <MenuItem value="and" sx={{ fontSize: '0.7rem' }}>
                                    И (все значения)
                                </MenuItem> */}
                            </Select>
                        </FormControl>
                        {/* Мульти-селект */}
                        <Autocomplete
                            multiple
                            options={options}
                            getOptionLabel={(option) => option.name}
                            getOptionKey={(option) => option.id}
                            value={filter.value || []}
                            onChange={(event, newValue) => handleMultiSelectChange(filter.id, newValue)}
                            size="small"
                            sx={{ width: '100%' }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    // placeholder="Выберите..."
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            fontSize: '0.7rem',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                            }
                                        },
                                        '& .MuiInputBase-input': {
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            '&::placeholder': {
                                                color: darkMode ? '#bbb' : '#666',
                                                opacity: 1
                                            }
                                        }
                                    }}
                                />
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        {...getTagProps({ index })}
                                        key={option.id}
                                        label={option.label}
                                        size="small"
                                        sx={{
                                            bgcolor: getChipColor(filter.id) || darkMode ? '#64b5f6' : '#1976d2',
                                            color: '#fff',
                                            fontSize: '0.65rem',
                                            height: '18px'
                                        }}
                                    />
                                ))
                            }
                            ListboxProps={{
                                sx: {
                                    bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                    '& .MuiAutocomplete-option': {
                                        color: darkMode ? '#f5f7fa' : '#333',
                                        fontSize: '0.7rem',
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                        },
                                        '&.Mui-focused': {
                                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)'
                                        }
                                    }
                                }
                            }}
                        />
                    </Box>
                );

            case 'boolean':
                return (
                    <FormControl size="small" fullWidth>
                        <Select
                            value={filter.value || ''}
                            onChange={(e) => handleFilterChange(filter.id, 'value', e.target.value)}
                            sx={{
                                bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                color: darkMode ? '#f5f7fa' : '#333',
                                fontSize: '0.7rem',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                }
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        '& .MuiMenuItem-root': {
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            fontSize: '0.7rem',
                                            '&:hover': {
                                                bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                            },
                                            '&.Mui-selected': {
                                                bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)',
                                                color: darkMode ? '#64b5f6' : '#1976d2'
                                            }
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value="" sx={{ fontSize: '0.7rem' }}>
                                Выберите значение
                            </MenuItem>
                            {booleanOperators.map(op => (
                                <MenuItem key={op.value} value={op.value} sx={{ fontSize: '0.7rem' }}>
                                    {op.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );

            case 'text':
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <FormControl size="small" fullWidth>
                            <Select
                                value={filter.operator || 'contains'}
                                onChange={(e) => handleFilterChange(filter.id, 'operator', e.target.value)}
                                sx={{
                                    bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontSize: '0.7rem',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            '& .MuiMenuItem-root': {
                                                color: darkMode ? '#f5f7fa' : '#333',
                                                fontSize: '0.7rem',
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                                },
                                                '&.Mui-selected': {
                                                    bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)',
                                                    color: darkMode ? '#64b5f6' : '#1976d2'
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="contains" sx={{ fontSize: '0.7rem' }}>
                                    Содержит
                                </MenuItem>
                                <MenuItem value="not_contains" sx={{ fontSize: '0.7rem' }}>
                                    Не содержит
                                </MenuItem>
                                <MenuItem value="equals" sx={{ fontSize: '0.7rem' }}>
                                    Равно
                                </MenuItem>
                                <MenuItem value="not_equals" sx={{ fontSize: '0.7rem' }}>
                                    Не равно
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            size="small"
                            fullWidth
                            value={filter.value || ''}
                            onChange={(e) => handleFilterChange(filter.id, 'value', e.target.value)}
                            // placeholder="Введите текст для поиска..."
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    bgcolor: darkMode ? '#1e1e1e' : '#fff',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontSize: '0.7rem',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                    }
                                },
                                '& .MuiInputBase-input': {
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    '&::placeholder': {
                                        color: darkMode ? '#bbb' : '#666',
                                        opacity: 1
                                    }
                                }
                            }}
                        />
                    </Box>
                );

            default:
                return null;
        }
    };

    return (
        <Box sx={{
            bgcolor: darkMode ? '#2b2b2b' : '#fff',
            border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
            borderRadius: 2,
            p: 1.5,
            mb: 1.5
        }}>
            {/* Селект и кнопка очистки на одной строке */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1.5
            }}>
                <FormControl size="small" sx={{ flex: 1 }}>
                    <Select
                        value=""
                        onChange={(e) => {
                            if (e.target.value) {
                                addFilter(e.target.value);
                            }
                        }}
                        displayEmpty
                        sx={{
                            bgcolor: darkMode ? '#1e1e1e' : '#f8f9fa',
                            color: darkMode ? '#f5f7fa' : '#333',
                            fontSize: '0.8rem',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: darkMode ? 'rgba(100, 181, 246, 0.4)' : 'rgba(25, 118, 210, 0.4)'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: darkMode ? '#64b5f6' : '#1976d2'
                            }
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                    '& .MuiMenuItem-root': {
                                        color: darkMode ? '#f5f7fa' : '#333',
                                        fontSize: '0.8rem',
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                        },
                                        '&.Mui-selected': {
                                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)',
                                            color: darkMode ? '#64b5f6' : '#1976d2'
                                        },
                                        '&.Mui-disabled': {
                                            color: darkMode ? '#666' : '#999'
                                        }
                                    }
                                }
                            }
                        }}
                    >
                        <MenuItem value="" disabled sx={{ fontSize: '0.8rem' }}>
                            + Добавить фильтр
                        </MenuItem>
                        {getAvailableFiltersForSelect().map(filter => (
                            <MenuItem key={filter.id} value={filter.id} sx={{ fontSize: '0.8rem' }}>
                                {filter.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Переключатель "По объектам/По кодам" - активен только при наличии определенных фильтров */}
                {(() => {
                    const hasRelevantFilter = advancedFilters.some(filter =>
                        ['checklist', 'status_ready', 'status_rejected', 'status_success'].includes(filter.id)
                    );

                    if (hasRelevantFilter) {
                        return (
                            <FormControl size="small">
                                <Select
                                    value={filterMode || 'objects'}
                                    onChange={(e) => handleFilterModeChange(e.target.value)}
                                    sx={{
                                        bgcolor: darkMode ? '#1e1e1e' : '#f8f9fa',
                                        color: darkMode ? '#f5f7fa' : '#333',
                                        fontSize: '0.8rem',
                                        minWidth: '140px',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(100, 181, 246, 0.4)' : 'rgba(25, 118, 210,0.4)'
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? '#64b5f6' : '#1976d2'
                                        }
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                                '& .MuiMenuItem-root': {
                                                    color: darkMode ? '#f5f7fa' : '#333',
                                                    fontSize: '0.8rem',
                                                    '&:hover': {
                                                        bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                                    },
                                                    '&.Mui-selected': {
                                                        bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.08)',
                                                        color: darkMode ? '#64b5f6' : '#1976d2'
                                                    }
                                                }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="objects" sx={{ fontSize: '0.8rem' }}>
                                        По объектам
                                    </MenuItem>
                                    <MenuItem value="codes" sx={{ fontSize: '0.8rem' }}>
                                        По кодам
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        );
                    }
                    return null;
                })()}

                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    disabled={advancedFilters.length === 0}
                    sx={{
                        color: darkMode ? '#f44336' : '#d32f2f',
                        '&:hover': {
                            bgcolor: darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(211, 47, 47, 0.1)'
                        },
                        '&.Mui-disabled': {
                            color: darkMode ? '#666' : '#ccc'
                        }
                    }}
                >
                    <ClearIcon fontSize="small" />
                </IconButton>
            </Box>

            {/* Компактный список активных фильтров */}
            {advancedFilters.length > 0 && (
                <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    alignItems: 'flex-start'
                }}>
                    {advancedFilters.map(filter => (
                        <Box
                            key={filter.id}
                            sx={{
                                border: darkMode ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(0,0,0,0.08)',
                                borderRadius: 1.5,
                                p: 1.5,
                                bgcolor: darkMode ? '#1e1e1e' : '#f8f9fa',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                minWidth: 'fit-content',
                                maxWidth: '300px',
                                '&:hover': {
                                    borderColor: darkMode ? 'rgba(100, 181, 246, 0.3)' : 'rgba(25, 118, 210, 0.3)',
                                    boxShadow: darkMode ? '0 2px 8px rgba(100, 181, 246, 0.1)' : '0 2px 8px rgba(25, 118, 210, 0.1)'
                                }
                            }}
                        >
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                mb: 1,
                                minWidth: 'fit-content'
                            }}>
                                <Typography variant="body2" sx={{
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    fontWeight: 500,
                                    fontSize: '0.75rem',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    flex: 1
                                }}>
                                    {filter.label}
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => removeFilter(filter.id)}
                                    sx={{
                                        color: darkMode ? '#f44336' : '#d32f2f',
                                        ml: 0.5,
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(211, 47, 47, 0.1)'
                                        }
                                    }}
                                >
                                    <DeleteIcon sx={{ fontSize: '0.9rem' }} />
                                </IconButton>
                            </Box>
                            <Box sx={{
                                width: '100%',
                                minWidth: 'fit-content'
                            }}>
                                {renderFilterControl(filter)}
                            </Box>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};